// extracted by mini-css-extract-plugin
export default {"btnpwd":"_7bf6ec5157"};